import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Global } from "../../Variables/Global";

const OrderDetails = ({ modalData, show, setShow }) => {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    let t = 0;
    modalData.OrderDetails.forEach(i => {
      t += i.OriginalPrice * i.Quantity;
    });
    setTotal(t);
  }, [modalData]);

  return (
    <Modal show={show} fullscreen onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          Order #{modalData.OrderNumber || modalData.OrderId}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {/* ===== Address ===== */}
        <div className="card mb-4 border-0 shadow-sm">
          <div className="card-body">
            <h6 className="mb-2">Delivery Address</h6>
            <p className="mb-1">
              <b>{modalData.AddressBook.FirstName} {modalData.AddressBook.LastName}</b>
            </p>
            <p className="mb-1">{modalData.AddressBook.Address1}</p>
            <p className="mb-1">{modalData.AddressBook.Address2}</p>
            <p className="mb-0">
              Phone: {modalData.AddressBook.PhoneNumber}
            </p>
          </div>
        </div>

        {/* ===== Items ===== */}
        <h6 className="mb-3">
          {modalData.OrderDetails.length} Items
        </h6>

        {modalData.OrderDetails.map((item, index) => (
          <div key={index} className="card mb-3 border-0 shadow-sm">
            <div className="card-body">
              <div className="row align-items-center">

                {/* Image */}
                <div className="col-3 col-md-2">
                  <img
                    src={Global.PHOTO_URL + item.ProductDetails.ImageUrl}
                    className="img-fluid rounded"
                    alt={item.ProductDetails.ProductName}
                  />
                </div>

                {/* Info */}
                <div className="col-9 col-md-6">
                  <h6 className="mb-1">
                    {item.ProductDetails.ProductName}
                    {item.AttributesValues?.length > 0 && (
                      <span className="text-muted">
                        {" "}({item.AttributesValues.join(" / ")})
                      </span>
                    )}
                  </h6>

                  <small className="text-muted">
                    SKU: {item.Sku}
                  </small>

                  <p className="mb-0">
                    Quantity: x{item.Quantity}
                  </p>
                </div>

                {/* Price */}
                <div className="col-md-4 text-md-end mt-2 mt-md-0">
                  <p className="mb-1">
                    Price: AED {item.OriginalPrice}
                  </p>
                  <b>
                    Total: AED {item.TotalPriceItem}
                  </b>
                </div>

              </div>
            </div>
          </div>
        ))}

        {/* ===== Total ===== */}
        <div className="card border-0 shadow-sm mt-4">
          <div className="card-body d-flex justify-content-between">
            <h5>Total</h5>
            <h5 className="text-danger">
              {modalData.Currency} {total}
            </h5>
          </div>
        </div>

        {/* ===== Notes ===== */}
        {modalData.Notes && (
          <div className="mt-3">
            <b>Notes:</b>
            <p>{modalData.Notes}</p>
          </div>
        )}

      </Modal.Body>
    </Modal>
  );
};

export default OrderDetails;
